/**
 * Socket handlers for financial updates and balance changes.
 * Use refreshFinancial for balance updates (not fetchMe) to avoid /api/auth/me spam.
 */
export function handleBalanceChanged(_, ctx) {
  ctx.safeRefreshFinancial?.();
}

export function handleFinancialUpdate(data, ctx) {
  if (!data?.userId) return;
  if (data?.ts && Date.now() - data.ts > 10000) return;
  if (ctx.user?._id && String(data.userId) !== String(ctx.user._id)) return;
  if (document.visibilityState !== "visible") return;
  if (ctx.refreshTimerRef?.current) return;

  ctx.refreshTimerRef.current = setTimeout(() => {
    ctx.safeRefreshFinancial?.();
    ctx.refreshTimerRef.current = null;
  }, 500);
}
